import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

/** Специальный селект для отображения выбранного языка */
const SelectDisabled = ({lang}) => {
    return <Select defaultValue={lang} disabled>
        <Option value={lang}>{lang}</Option>
    </Select>
}
/** Специальный select для выбор  языка */
const SelectEditable = ({lang, placeholder, onChange}) => {
    return <Select defaultValue={lang} onChange={onChange} placeholder={placeholder} >
        <Option value=""></Option>
        <Option value="ru">ru</Option>
        <Option value="en">en</Option>
    </Select>
}
/** Специальная компоненты  управления доступными языками */
const LanguageNode = ({lang, editable, placeholder, onChange=f=>f}) => {
    const Component = editable? SelectEditable: SelectDisabled;
    return (
     <Component lang={lang} placeholder={placeholder} onChange={onChange} />
)}

export default LanguageNode;